import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { ALL_ROUTES } from '../consts/routes';
import { ForgotPassword, Login, TwoFactorSetup } from '../pages';
import { createProtectedRoute } from '../utils/createProtectedRoute';
import { VerifyRoute } from '../utils/VerifyRoute';
import { OnboardLayout } from '@/Layouts/Onboard/Onboard.layout';

/**
 * Public/authentication routes
 * - Login, forgot password
 * - Note: join-organization and new-password are in a separate function
 */
export const useAuthRoutes = (): RouteObject[] => {
  return [
    {
      path: '/',
      element: <VerifyRoute needAuth={false} element={<OnboardLayout />} />,
      children: [
        {
          path: ALL_ROUTES.FORGOT_PASSWORD,
          element: createProtectedRoute({
            page: ForgotPassword,
            needAuth: false,
            hasPrivileges: true,
          }),
        },
        {
          path: ALL_ROUTES.TWO_FACTOR_SETUP,
          element: createProtectedRoute({
            page: TwoFactorSetup,
            needAuth: false,
            hasPrivileges: true,
          }),
        },
        {
          index: true,
          element: createProtectedRoute({
            page: Login,
            needAuth: false,
            hasPrivileges: true,
          }),
        },
        {
          path: ALL_ROUTES.LOGIN_ALT,
          element: <Navigate to={ALL_ROUTES.LOGIN} replace />,
        },
      ],
    },
  ];
};
